import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { AppRouterService } from '@app/services/app/router.service';
import { ProjectsService, ProjectsEditorService } from '@app/services/app/projects.service';
import { AppService } from '@app/services/app/app.service';
import { AddProjectService } from '@app/services/app/add-project.service';


import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionListItemMenuClick } from '@core/components/versions/list/version-list-item-menu-click';
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';

import { NotificationsService } from '@core/services/notifications/notifications.service';

@Component({
    selector: 'project-details-versions-uploaded',
    templateUrl: './uploaded.component.html',
    styleUrls: ['./uploaded.component.scss']
})
export class ProjectDetailsVersionsUploadedComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    public readonly ACCESS_REQUEST_FEEDBACK = 'share_feedback';
    public readonly ACCESS_ADD_PROJECT = "access_global_new_request";
    public readonly ACCESS_UPLOAD_VERSION = "access_request_upload_version";

    @Input() project: Objects.ExtendedRequest;
    @Input() versions: Array<Objects.Version> = [];
    @Input() feedbacks: Array<VersionShareItem> = null;
    public status:number = this.LOADING;
    public feedbackPluginAccess: boolean = false;
    public addProjectAccess: boolean = false;
    public uploadVersionAccess: boolean = false;


    protected subscriptor: Subscription;
    protected accessProjectSubscriptor: Subscription;

    public menu: Array<ThreeDotsMenuItem> = [
        {
            title: "Download All Files",
            key: "download-all",
            icon: "download",
            order: 1
        },
        {
            title: "See Artwork Details",
            key: "details",
            icon: "see-details",
            order: 2
        },
        // ARTWORK IS UPLOADED ALWAYS
        {
            title: "See Original Project",
            key: "see-project",
            icon: "see-project",
            order: 3
        }
    ];

    // optional menu item
    protected menuAddProject: ThreeDotsMenuItem = {
        title: "Start New Project",
        key: "add-project",
        icon: "add",
        order: 5
    };

     // optional menu item
     protected menuUploadVersion: ThreeDotsMenuItem = {
        title: "Upload Artwork",
        key: "upload-artwork",
        icon: "upload_artwork",
        order: 4
    };



    constructor( public app: AppService,
        private AddProjectSrv: AddProjectService,
        private appRouter: AppRouterService,
        private projectsSrv: ProjectsService,
        private notifSrv: NotificationsService,
        private projectEditorSrv: ProjectsEditorService, ) { }

    ngOnInit() {
        // get plugins access
        this.subscriptor = this.app.getSession().subscribe( (session: any) => {
            this.feedbackPluginAccess = session.options.plugins.some((pa) => pa == this.ACCESS_REQUEST_FEEDBACK);
            this.addProjectAccess = session.options.access.hasOwnProperty(this.ACCESS_ADD_PROJECT)? session.options.access[this.ACCESS_ADD_PROJECT] : false;
            if(this.addProjectAccess){
                this.updateMenu(this.menuAddProject, true);
            }
        });

        // subscribe to upload version access
        this.accessProjectSubscriptor = this.projectEditorSrv.selectAccess(this.ACCESS_UPLOAD_VERSION).subscribe((access: boolean) => {
            this.uploadVersionAccess = access;
            this.updateMenu(this.menuUploadVersion,this.uploadVersionAccess);
        });

    }

    ngOnDestroy() {
        this.subscriptor.unsubscribe();
    }

    init(){

        if(this.project == null || this.versions == null)
            return;
        this.status = this.DONE;
    }

    onMenuClick(menu: VersionListItemMenuClick) {
        // console.debug(" menu version item  click ",menu);
        switch(menu.key) {
            case "download-all":
                // start notification to download compressed version files in zip
                this.notifSrv.addNotification(NotificationsContextEnum.EVENT_FILES_COMPRESSION_START, {id: menu.version.id, details: { url: "/versions/"+menu.version.id }});
                break;
            case "details":
                if(this.project != null)
                    // go to version Details
                    this.appRouter.navigate("/versions/"+menu.version.id);
                break;
            case "see-project":
                // navigate
                if(menu.version != null){
                    // this.versionsSrv.getProject$(menu.version).subscribe((originalProject: Objects.Request) => {
                        if(this.project != null)
                            this.appRouter.navigate('/projects/'+this.project.id);
                    // });
                }
                break;
            case "add-project":
                if(menu.version != null){
                    this.AddProjectSrv.clear();
                    this.appRouter.navigate('/projects/add', { queryParams: { version: menu.version.id } });
                }
                break;
            case "upload-artwork":
                this.appRouter.navigate('/projects/'+this.project.id+'/versions/add', { queryParams: { links: menu.version.labels.map((l: Objects.Label) => l.id).sort().join("-") } });
                break;
        }
    }

    onFileClick(version: Objects.Version,file: Objects.File){
        // console.debug(" versions click file preview ",file);
        if (file != null && this.project != null){
            // TODO set this url to preview version FILE
            this.appRouter.navigate('/projects/'+this.project.id + "/versions/"+version.id + "/files/"+file.id);
        }
    }

    public updateVersionStatus(status, version){
        // console.log(" VERSION status updated here ",version.id,status.name)
        this.projectsSrv.setUploadedVersionStatus(version,status)
    }

    public getFeedbacks(version: Objects.Version){
        return this.feedbacks!= null ? this.feedbacks.filter((f: VersionShareItem) => f.version.id == version.id) : null;
    }

    protected addToMenu(item: ThreeDotsMenuItem) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        this.menu.push(item);
    }

    // this function check either remove or add item. based on subscribed events
    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

}
